module.exports = __webpack_public_path__ + "img/bg_image_3.c084850c.png";